import React, { useContext, useEffect, useState } from "react";
import sld from "../../images/sld/Rectangle.svg";
import Ecc from "../../components/PVHYBRIDIZATION/Ecc";
import embLabels from "../../config/emb-labels-en.json";
import { DesignAssetContext } from "../CustomHooks/ContextApi";
import Linebar from "../../components/GRIDCONNECTED/Linebar";
import Utility from "../../components/ETOGrid/Utility";
import Battery from "../../components/ETOGrid/Battery";
import Load from "../../components/ETOGrid/Load";
import Busbar from "../../components/ReusableSvg/Busbar";
import PV from "../../components/ETOGrid/PV";
import EV from "../../components/ETOGrid/EV";
import LoadPvBess from "../../components/GensetPvBess/LoadPvBess";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const GridEtoSLD = () => {
  const {
    CBAssetList,
    CBLoadList,
    CBEVList,
    sldLoadCompleted,
    switchboardType,
    siteType,
    count,
    loadSide,
    isExportOptimization,
  } = useContext(DesignAssetContext);
  // State to force re-render on CBLoadList change
  const [loadListVersion, setLoadListVersion] = useState(0);
  useEffect(() => {
    setLoadListVersion((v) => v + 1);
  }, [CBLoadList, sldLoadCompleted]);
  const projectTypeValue = useProjectTypeValue();
  const multipleLoadsAllowed = siteType === "GRID_CONNECTED" && isExportOptimization && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue)?true:false;
  const PV1AssetData = CBAssetList[3];
  const PV2AssetData = CBAssetList[4];
  const PV3AssetData = CBAssetList[5];
  const getLoadXPosition = ()=>{
   if(multipleLoadsAllowed){
     if(switchboardType === embLabels?.EXISTING_SWITCHBOARD){
     return count?.derCount === 5
      ? count?.evCount ==1?130:180
      :count?.derCount === 4
      ?count?.evCount ==1?170:230
      :count?.derCount === 3
      ?count?.evCount ==1?100:170:count?.evCount === 1?-80:0
    }else{
      return count?.derCount === 5
      ? count?.evCount ==1?230:300
      :count?.derCount === 4
      ?count?.evCount ==1?230:280
      :count?.derCount === 3?count?.evCount ==1?(projectTypeValue === "MGaaS ETO" &&  siteType === "GRID_CONNECTED" && isExportOptimization )?240:190:(projectTypeValue === "MGaaS ETO" &&  siteType === "GRID_CONNECTED" && isExportOptimization )?300:230:count?.evCount === 1?-80:0
    }
   }else{
     if(switchboardType === embLabels?.EXISTING_SWITCHBOARD){
     return 10; 
    }else{
      return count?.derCount === 5
      ? count?.evCount ==1?170:130
      :count?.derCount === 4
      ?count?.evCount ==1?150:170
      :count?.derCount === 3
      ?count?.evCount ==1?50:0:count?.evCount === 1?-80:0
    }
   }
   
    
  }
  const getLoadYPosition = () =>{
    if(multipleLoadsAllowed){
      return switchboardType === embLabels?.EXISTING_SWITCHBOARD ? loadSide === "LOAD_SIDE"?-20:40:70;
    }else{
      return 0;
    }
  }
  const getEvXPosition = ()=>{
    if(switchboardType === embLabels?.EXISTING_SWITCHBOARD){
      return   count?.derCount === 5
      ? multipleLoadsAllowed?260: 190
      : count?.derCount === 4
      ? multipleLoadsAllowed?210:160
      : count?.derCount === 3
      ? multipleLoadsAllowed?150:100
      : 0
    }else{
      return  count?.derCount === 6
      ?  50
      : count?.derCount === 5
      ? multipleLoadsAllowed?230:100
      : count?.derCount === 4
      ? multipleLoadsAllowed?200:70
      : count?.derCount === 3
      ? multipleLoadsAllowed?130:0
      : 0
    }
   
  }
  const areAllConfigured = () =>{
    const loadList = CBLoadList?.filter(load => !load.uiData.isRemoteLoad);
    return loadList.every(item => item.uiData.configured);
  }
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
      data-load-list-version={loadListVersion}
    >
      <svg viewBox="0 0 1300 800">
        <g>
          <svg x="0" y="0" viewBox="0 0 1300 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>

            <g
              id="components-sld"
              key={`components-sld-${loadListVersion}`}
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
              <Ecc />
              {switchboardType === embLabels?.EXISTING_SWITCHBOARD &&
                siteType === "GRID_CONNECTED" && <Linebar />}
              <Busbar
                secondBusbar={
                  switchboardType === embLabels?.EXISTING_SWITCHBOARD &&
                  siteType === "GRID_CONNECTED"
                    ? true
                    : false
                }
              />
              <Utility />
              {CBAssetList[2]?.uiData?.status && <Battery />}
              {CBAssetList[3]?.uiData?.status && (
                <PV
                  pvIndex={3}
                  uiData={PV1AssetData?.uiData}
                  cbConfigData={PV1AssetData?.cbConfigData}
                  powerMeterData={PV1AssetData?.powerMeterData}
                />
              )}
              {CBAssetList[4]?.uiData?.status && (
                <PV
                  pvIndex={4}
                  uiData={PV2AssetData?.uiData}
                  cbConfigData={PV2AssetData?.cbConfigData}
                  powerMeterData={PV2AssetData?.powerMeterData}
                />
              )}
              {CBAssetList[5]?.uiData?.status && (
                <PV
                  pvIndex={5}
                  uiData={PV3AssetData?.uiData}
                  cbConfigData={PV3AssetData?.cbConfigData}
                  powerMeterData={PV3AssetData?.powerMeterData}
                />
              )}

              <svg
                x={ 
                
                  getLoadXPosition()
                   }
                y={getLoadYPosition()}
              >
                {
                  multipleLoadsAllowed === true &&  CBLoadList?.length > 0 &&
                  <>
                  {console.log("Render LoadPvBess")}
                      <LoadPvBess
                      loadLength = {count}
                        configured = {areAllConfigured()}
                      />
                      </>
                }
                { multipleLoadsAllowed === false &&
                CBLoadList?.map((loadData, key) => (
                  <Load
                    key={loadData?.uiData?.xAxis}
                    load={loadData?.uiData}
                    loadName={loadData?.configData?.name}
                    index={key}
                  />
                ))}
              </svg>
              <svg
                x={
                 
                  getEvXPosition()
                }
                y="0"
              >
                {CBEVList?.map(
                  (cbData, key) =>
                    cbData?.uiData?.status && (
                      <EV
                        key={cbData?.configData?.name}
                        index={key}
                        status={cbData?.uiData?.status}
                      />
                    )
                )}
              </svg>
            </g>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default GridEtoSLD;
